import { SVGProps } from 'react';

const IcEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
    <g clipPath='url(#clip0_24503_539361)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 19.8811H19.6763V18.0164H0V19.8811ZM6.88671 13.3548V10.8468L15.3219 3.35266L17.1233 5.25557L9.4102 13.3548H6.88671ZM20 5.25743L15.3761 0.833496L4.91909 10.0599V15.2194H10.2523L20 5.25743Z'
        fill={props.fill || '#1D2129'}
      />
    </g>
    <defs>
      <clipPath id='clip0_24503_539361'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export default IcEdit;
